import React, { useState, useEffect, useContext } from "react";
import "./familyDetails.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/successImg.png";
import { ToastContainer, toast } from "react-toastify";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import { object, string } from "yup";
import translations from "./translation.json";
import { LanguageContext } from "../../Components/LanguageContext";
import CircularProgress from "@mui/material/CircularProgress";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
const FamilySchema = object({
  total_brothers: string().required("this feild is required"),
  total_sisters: string().required("this feild is required"),
  married_brothers: string().required("this feild is required"),
  married_sisters: string().required("this feild is required"),
});
export function FamilyDetails() {
  const { language } = useContext(LanguageContext);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const params = useParams();
  const userid = params.id;

  const formik = useFormik({
    initialValues: {
      father_name: "",
      father_occupation: "",
      mother_name: "",
      mother_occupation: "",
      total_brothers: "",
      total_sisters: "",
      married_brothers: "",
      married_sisters: "",
    },
    // validationSchema: FamilySchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const dataToSave = {
          ...values,
          total_brothers: Number(values.total_brothers) || 0,
          total_sisters: Number(values.total_sisters) || 0,
          married_brothers: Number(values.married_brothers) || 0,
          married_sisters: Number(values.married_sisters) || 0,
        };

        const response = await axiosInstance.patch(
          `biodata/${userid}`,
          dataToSave
        );
        if (response.data.status === true) {
          handleOpen();
          setTimeout(() => {
            handleClose();
          }, 1000);
        }
      } catch (error) {
        setLoading(true);
        toast.error(error.response.data.message || "Submission failed!");
        console.error("Error saving to localStorage:", error);
      } finally {
        setLoading(false);
      }
    },
  });

  async function LoadUser(id) {
    try {
      const response = await axiosInstance.get(`biodata/${id}`);
      const { data } = response.data;
      if (data) {
        const {
          father_name = "",
          father_occupation = "",
          mother_name = "",
          mother_occupation = "",
          total_brothers = "",
          total_sisters = "",
          married_brothers = "",
          married_sisters = "",
        } = data;

        formik.setValues({
          father_name,
          father_occupation,
          mother_name,
          mother_occupation,
          total_brothers,
          total_sisters,
          married_brothers,
          married_sisters,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch data");
      console.error("Error fetching user details", error);
    }
  }
  useEffect(() => {
    LoadUser(params.id);
  }, []);

  return (
    <form onSubmit={formik.handleSubmit}>
      {loading && (
        <div className="loader-overlay">
          <CircularProgress style={{ color: "#f24464" }} />
        </div>
      )}
      <div>
        {/* row1 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              {translations[language].father_name}
            </div>
            <div className="family-input">
              <input
                type="text"
                placeholder="Enter Father Name"
                onChange={formik.handleChange}
                id="father_name"
                value={formik.values.father_name}
              />
            </div>
          </div>
          <div>
            <div className="family-label">
              {translations[language].father_occupation}
            </div>
            {/* <div>
            <select className="dropdown-btnFamily">
              <option>Select </option>
            
              <option>type 1</option>
            </select>
          </div> */}
            <div className="family-input">
              <input
                type="text"
                placeholder="Enter Father's Occupation"
                onChange={formik.handleChange}
                id="father_occupation"
                value={formik.values.father_occupation}
              />
            </div>
          </div>
        </div>
        {/* row2 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              {translations[language].mother_name}
            </div>
            <div className="family-input">
              <input
                type="text"
                placeholder="Enter Mother Name"
                onChange={formik.handleChange}
                id="mother_name"
                value={formik.values.mother_name}
              />
            </div>
          </div>
          <div>
            <div className="family-label">
              {translations[language].mother_occupation}
            </div>
            {/* <div>
            <select className="dropdown-btnFamily">
              <option>Select </option>
            
              <option>type 1</option>
            </select>
          </div> */}
            <div className="family-input">
              <input
                type="text"
                placeholder="Enter Mother's Occupation"
                onChange={formik.handleChange}
                id="mother_occupation"
                value={formik.mother_occupation}
              />
            </div>
          </div>
        </div>
        {/* row3 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              {translations[language].no_of_brothers}{" "}
            </div>
            {/* <div>
            <select className="dropdown-btnFamily">
              <option>Select </option>
            
              <option>type 1</option>
            </select>
          </div> */}
            <div className="family-input">
              {/* <input
                type="text"
                placeholder="Enter No. of Brothers"
                onChange={formik.handleChange}
                id="total_brothers"
                value={formik.values.total_brothers}
              /> */}
              <select
                name="total_brothers"
                id="total_brothers"
                value={formik.values.total_brothers}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.total_brothers && formik.errors.total_brothers
                    ? "error"
                    : ""
                }`}
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
              <div>
                {formik.touched.total_brothers &&
                  formik.errors.total_brothers && (
                    <div className="text-danger">
                      {formik.errors.total_brothers}
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div>
            <div className="family-label">
              {translations[language].no_of_sisters}
            </div>
            {/* <div>
            <select className="dropdown-btnFamily">
              <option>Select </option>
            
              <option>type 1</option>
            </select>
          </div> */}
            <div className="family-input">
              {/* <input
                type="text"
                placeholder="Enter No. of Sisters"
                onChange={formik.handleChange}
                id="total_sisters"
                value={formik.values.total_sisters}
              /> */}
              <select
                name="total_sisters"
                id="total_sisters"
                value={formik.values.total_sisters}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.total_sisters && formik.errors.total_sisters
                    ? "error"
                    : ""
                }`}
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
              <div>
                {formik.touched.total_sisters &&
                  formik.errors.total_sisters && (
                    <div className="text-danger">
                      {formik.errors.total_sisters}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        {/* row4 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              {translations[language].married_brothers}{" "}
            </div>

            <div className="family-input">
              {/* <input
                type="text"
                placeholder="Enter Married Brothers"
                onChange={formik.handleChange}
                id="married_brothers"
                value={formik.values.married_brothers}
              /> */}
              <select
                name="married_brothers"
                id="married_brothers"
                value={formik.values.married_brothers}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.married_brothers &&
                  formik.errors.married_brothers
                    ? "error"
                    : ""
                }`}
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
              <div>
                {formik.touched.married_brothers &&
                  formik.errors.married_brothers && (
                    <div className="text-danger">
                      {formik.errors.married_brothers}
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div>
            <div className="family-label">
              {translations[language].married_sisters}{" "}
            </div>

            <div className="family-input">
              {/* <input
                type="text"
                placeholder="Enter Married Sisters"
                onChange={formik.handleChange}
                id="married_sisters"
                value={formik.values.married_sisters}
              /> */}
              <select
                name="married_brothers"
                id="married_brothers"
                value={formik.values.married_brothers}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.married_brothers &&
                  formik.errors.married_brothers
                    ? "error"
                    : ""
                }`}
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
              <div>
                {formik.touched.married_sisters &&
                  formik.errors.married_sisters && (
                    <div className="text-danger">
                      {formik.errors.married_sisters}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>

        {/* modal */}
        <div>
          <div className="btnBasicSave">
            <Button type="submit">{translations[language].btnSave}</Button>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose} //close modal on background click
            closeAfterTransition
          >
            <Fade in={open}>
              <Box sx={style} className="modal-box">
                <img srcSet={successImg} />
                <Typography
                  id="transition-modal-title"
                  variant="h6"
                  component="h2"
                >
                  Thank You
                </Typography>
                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  The profile has been successfully updated
                </Typography>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </form>
  );
}
